import React, { PropTypes } from 'react';
// import { compose } from 'redux';
import {DragDropContext} from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import NavBar from './navigation/NavBar';
import CustomDragLayer from './DragMemberPreview';
import withScrolling from 'react-dnd-scrollzone';
import 'react-select/dist/react-select.css';
// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.
const SZone = withScrolling('div');
const isTouchDevice = 'ontouchstart' in document.documentElement;
class ScrollZone extends React.Component {
  render() {
    return (
      <SZone className={'app-scroll-zone'}>
        <NavBar />
        {this.props.children}
        {isTouchDevice && <CustomDragLayer key="__preview" name="Item"/>}
      </SZone>
    );
  }
}

ScrollZone.propTypes = {
  children: PropTypes.element
};

export default DragDropContext(isTouchDevice ? TouchBackend : HTML5Backend)(ScrollZone);



/** WEBPACK FOOTER **
 ** ./src/components/ScrollZone.js
 **/